import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useConfig } from '../../hooks';
import { getFontSize } from '../../utilities';
import ButtonAction from '../ButtonAction';
import ButtonBase from '../ButtonBase';
import RelatedIcon from '../Icons/Chain';
import ChevronRightBold from '../Icons/ChevronRightBold';
import ToolTip from '../ToolTip';

const RelatedQuestion = ({
  classicView,
  onRelatedQuestionsShow,
  relatedQuestions,
  horizontalPosition
}) => {
  const { fontFamily, button, message } = useConfig();
  const { t } = useTranslation();

  const hasRelatedQuestions = relatedQuestions && relatedQuestions.length > 0;
  const textFontSize = getFontSize(message);

  const handleRelatedQuestionsShow = () => {
    if (onRelatedQuestionsShow && hasRelatedQuestions) {
      onRelatedQuestionsShow(relatedQuestions);
    }
  };

  if (!hasRelatedQuestions) return null;

  if (classicView) {
    return (
      <ButtonRelated
        {...button}
        onClick={handleRelatedQuestionsShow}
        textFontFamily={fontFamily}
        textFontSize={textFontSize}
      >
        {t('relatedQuestions')}
        <ChevronRightBold fill={button.color} />
      </ButtonRelated>
    );
  }
  return (
    <ToolTip
      text={t('relatedQuestions')}
      position={horizontalPosition ? 'left' : 'top'}
      textFontFamily={fontFamily}
    >
      <ButtonIcon backgroundColor={message.accentColor} onClick={handleRelatedQuestionsShow}>
        <RelatedIcon fill={message.fill} />
      </ButtonIcon>
    </ToolTip>
  );
};

RelatedQuestion.propTypes = {
  /**
   * Component has another view (button with text and  without icon).
   */
  classicView: PropTypes.bool,
  /**
   * Function fired when user clicks on `Related Questions` button.
   */
  onRelatedQuestionsShow: PropTypes.func,
  /**
   * Array of related questions.
   */
  relatedQuestions: PropTypes.arrayOf(
    PropTypes.shape({
      ProjectId: PropTypes.number,
      ProjectName: PropTypes.string
    })
  ),
  /**
   * ToolTip will be shown left on `Related Questions` if block has horizontal position.
   */
  horizontalPosition: PropTypes.bool
};

RelatedQuestion.defaultProps = {
  relatedQuestions: []
};

const ButtonIcon = styled(ButtonAction)`
  :hover {
    background-color: ${({ backgroundColor }) => `${backgroundColor}`};
  }
`;

const ButtonRelated = styled(ButtonBase)`
  font-family: ${props => props.textFontFamily};
  font-size: ${props => props.textFontSize}px;
  font-weight: 700;
  line-height: 20px;
  color: ${props => props.color};
  & svg {
    width: 10px;
    margin-left: 4px;
  }
`;

export default RelatedQuestion;
